import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../components/Button';
interface SystemErrorProps {
  onRetry: () => void;
  onBack: () => void;
}
export function SystemError({
  onRetry,
  onBack
}: SystemErrorProps) {
  return <div className="flex flex-col items-center justify-center h-full w-full bg-stone-50 px-6 relative overflow-hidden" data-id="element-1162">
      <div className="relative z-10 flex flex-col items-center w-full max-w-sm" data-id="element-1163">
        <div className="w-24 h-24 rounded-3xl overflow-hidden border-4 border-white shadow-md bg-stone-200 mb-6 relative" data-id="element-1164">
          <video autoPlay loop muted playsInline className="w-full h-full object-cover grayscale opacity-80" src="https://cdn.magicpatterns.com/uploads/69mUG6ooMsKbP89Ta37mkt/Katethought_friendly_gym_mascot_character_funny_good_guy_musc_bc3cfd10-111a-4766-8e76-81af2852edc8_2.mp4" data-id="element-1165" />
          <div className="absolute inset-0 bg-pink-500/10 mix-blend-multiply" data-id="element-1166" />
        </div>

        <div className="w-12 h-12 bg-pink-50 text-pink-500 rounded-full flex items-center justify-center mb-4" data-id="element-1167">
          <AlertTriangle size={24} data-id="element-1168" />
        </div>

        <div className="text-center mb-8" data-id="element-1169">
          <h2 className="text-2xl font-extrabold text-slate-800 tracking-tight mb-2" data-id="element-1170">
            Oops, something went wrong
          </h2>
          <p className="text-slate-500 font-medium leading-relaxed" data-id="element-1171">
            We couldn't connect to the server. Let's try that again, or you can
            go back to the previous screen.
          </p>
        </div>

        <div className="w-full space-y-3" data-id="element-1172">
          <Button variant="primary" fullWidth onClick={onRetry} data-id="element-1173">
            Try again
          </Button>
          <Button variant="outline" fullWidth onClick={onBack} data-id="element-1174">
            Go back
          </Button>
        </div>
      </div>
    </div>;
}